// import { getProductCount } from '../../redux/action/productAction'
import { getCategoryData } from '../../redux/action/categoryAction'
import { getSubCategoryData } from '../../redux/action/subcategoryAction'
import { getSubCategoryOneData } from '../../redux/action/subonecategoryAction'
import { getSubCategoryTwoData } from '../../redux/action/subtwocategoryAction'
import { connect } from 'react-redux'
import landingMarketplace from './landingMarketplace'

const mapStoreToProps = state => ({
  // productCount: state.product.products,
  categoryData: state.category.categorys,
  subcategoryData: state.subcategory.subcategorys,
  subonecategoryData: state.subonecategory.subonecategorys,
  subtwocategoryData: state.subtwocategory.subtwocategorys
})
const mapDispatchToProps = dispatch => ({
  // getProductCount: (sendData)=>dispatch(getProductCount(sendData)),
  getCategoryData: ()=>dispatch(getCategoryData()),
  getSubCategoryData: (requestdata)=>dispatch(getSubCategoryData(requestdata)),
  getSubCategoryOneData: (requestdata)=>dispatch(getSubCategoryOneData(requestdata)),
  getSubCategoryTwoData: (requestdata)=>dispatch(getSubCategoryTwoData(requestdata))
})

export default connect(mapStoreToProps, mapDispatchToProps)(landingMarketplace)